(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntitySelectorViaTemplateDialogCtrl', EntitySelectorViaTemplateDialogCtrl);

    EntitySelectorViaTemplateDialogCtrl.$inject = [
        '$q',
        '$scope',
        'DialogInstance'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for selecting one entity via the entity template.
     */
    function EntitySelectorViaTemplateDialogCtrl(
        $q,
        $scope,
        DialogInstance) {

        /* jshint validthis:true */
        var vm = this;
        vm.selectedEntity = null;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok() {
            DialogInstance.ok(vm.selectedEntity);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
